/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplicationDocumentCombineRequest as ModelsV3ApplicationApplicationDocumentCombineRequest } from '../../models/Models/v3/Application/application-document-combine-request';

export interface V3ApplicationsDocumentsCombinePost$Json$Json$Params {
      body?: ModelsV3ApplicationApplicationDocumentCombineRequest
}

export function v3ApplicationsDocumentsCombinePost$Json$Json(http: HttpClient, rootUrl: string, params?: V3ApplicationsDocumentsCombinePost$Json$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationsDocumentsCombinePost$Json$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

v3ApplicationsDocumentsCombinePost$Json$Json.PATH = '/v3/applications/documents/combine';
